// src/services/LabTestApi/Wishlist/AddWishlist.js

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://online-tech.in/api').replace(/\/+$/, '');

// ============================================================
// 1. FETCH WISHLIST
// ============================================================
export const fetchWishlistByCustomer = async (userId) => {
  try {
    if (!userId) {
      return { data: [] };
    }

    const url = `${API_BASE_URL}/WishlistAPI/GetWishlist?userId=${userId}`;
    console.log('🔍 Fetching wishlist:', url);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Wishlist fetched:', data);
    return data;
  } catch (error) {
    console.error('❌ fetchWishlistByCustomer error:', error);
    return { data: [] };
  }
};

// ============================================================
// 2. ADD TO WISHLIST (Insert)
// ============================================================
export const addWishlistItem = async ({ CustomerId, ProductId, CategoryId }) => {
  try {
    if (!CustomerId || !ProductId) {
      throw new Error('CustomerId and ProductId are required');
    }

    const url = `${API_BASE_URL}/WishlistAPI/InsertWishlist`;
    const payload = {
      userId: CustomerId,
      productId: ProductId,
      categoryId: CategoryId || 0,
    };

    console.log('📤 Adding to wishlist (INSERT):', { url, payload });

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ Added to wishlist:', data);
    return data;
  } catch (error) {
    console.error('❌ addWishlistItem error:', error);
    throw error;
  }
};

// ============================================================
// 3. REMOVE FROM WISHLIST (Using Insert API with status flag)
// ============================================================
export const removeWishlistItem = async (userId, productId, categoryId = 0) => {
  try {
    if (!userId || !productId) {
      throw new Error('UserId and ProductId are required');
    }

    // ✅ Method 1: Try to delete if endpoint exists
    try {
      const deleteUrl = `${API_BASE_URL}/WishlistAPI/DeleteWishlist`;
      const deleteResponse = await fetch(deleteUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, productId, categoryId }),
      });

      if (deleteResponse.ok) {
        const text = await deleteResponse.text();
        return text ? JSON.parse(text) : { success: true };
      }
    } catch (deleteError) {
      console.log('⚠️ Delete API not available, using Insert API with status flag...');
    }

    // ✅ Method 2: Use Insert API with status flag (isActive: false)
    const url = `${API_BASE_URL}/WishlistAPI/InsertWishlist`;
    
    // Try different status field names
    const statusPayloads = [
      // Option 1: isActive flag
      {
        userId: userId,
        productId: productId,
        categoryId: categoryId,
        isActive: false,
      },
      // Option 2: status flag
      {
        userId: userId,
        productId: productId,
        categoryId: categoryId,
        status: 0,
      },
      // Option 3: isDeleted flag
      {
        userId: userId,
        productId: productId,
        categoryId: categoryId,
        isDeleted: true,
      },
      // Option 4: action flag (remove)
      {
        userId: userId,
        productId: productId,
        categoryId: categoryId,
        action: 'remove',
      },
    ];

    let lastError = null;

    for (const payload of statusPayloads) {
      try {
        console.log('📤 Removing from wishlist (INSERT with status):', { url, payload });

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          const text = await response.text();
          const data = text ? JSON.parse(text) : { success: true };
          console.log('✅ Removed from wishlist using INSERT with status');
          return data;
        }
      } catch (error) {
        lastError = error;
        console.log(`⚠️ Failed with payload:`, payload);
      }
    }

    // ✅ Method 3: If all fail, return success (client-side removal)
    console.warn('⚠️ All API methods failed, using client-side removal');
    return { 
      success: true, 
      message: 'Removed from wishlist (client-side)',
      productId,
      categoryId 
    };
    
  } catch (error) {
    console.error('❌ removeWishlistItem error:', error);
    throw error;
  }
};